import React, { FunctionComponent, memo } from "react"

import { Coordinates } from "@/types";
import { Circle } from "@react-google-maps/api"

export interface IMapCircleProps {
    center: Coordinates
    radius: number
    options?: IMapCircleOptionsProps
}

export interface IMapCircleOptionsProps {
    fillColor?: string
    fillOpacity?: number
    strokeColor?: string
    strokeOpacity?: number
    strokeWeight?: number
    zIndex?: number;
}

const MapCircle: FunctionComponent<IMapCircleProps> = ({
    center,
    radius,
    options,
}) => {
    return (
        <Circle
            center={center}
            radius={radius}
            options={options}
        />
    )
}

export default memo(MapCircle)
